const AutocompleteAddress = ({
  city = '',
  name = '',
  propertyId = '',
  state = '',
  street = '',
  zip = '',
  streetNumber = '',
} = {}) => ({
  city: String(city),
  name: String(name),
  propertyId: String(propertyId),
  state: String(state),
  street: String(street),
  zip: String(zip),
  streetNumber: String(streetNumber),
});

export default AutocompleteAddress;
